module.exports = __webpack_public_path__ + "img/batch.fbb2e8e0.png";